import TopNav from '@components/Nav/TopNav';
import TipDirectLeftMenu from '@components/Nav/TopNav/TipDirectLeftMenu';
import { TapToTipTabs } from '@components/Nav/TopNav/tipDirectTabs';
import { StyleBreakpoints } from '@constants';
import { makeStyles } from '@material-ui/core/styles';
import { useIsFeatureForCompanyEnabled } from '@utils/hooks';
import * as R from 'ramda';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import * as actions from './actions';
import reducer from './reducer';
import saga from './saga';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up(StyleBreakpoints.sm)]: {
      flexDirection: 'row'
    }
  }
}));

// Card 354 — this used to be a second copy of the enum, the one the mobile
// menu imported, and every tab had to be added to both by hand. There is one
// now, defined with the tabs themselves; re-exported here for existing imports.
export { TapToTipTabs };

function TapToTipPage({
  transactions,
  fetchTransactions,
  sendInvitesToGuides,
  user,
  profile,
  fetchProfile,
  updateProfile,
  isLoading,
  uploadUserProfileImage,
  connectStripeResponse,
  connectStripe,
  agentsProfiles,
  fetchAgentsProfiles,
  revokeInvite,
  activeTours,
  tours,
  fetchActiveTours,
  fetchTours,
  addToursToProfile,
  addTapToTipTour,
  editTapToTipTour,
  reviewsStatistic,
  fetchReviewsStatistic,
  multipleAssign,
  deleteTour,
  match
}) {
  useInjectReducer({ key: 'taptotip', reducer });
  useInjectSaga({ key: 'taptotip', saga });
  const history = useHistory();

  const classes = useStyles();
  const intl = useIntl();
  const { tab } = useParams();
  const location = useLocation();
  // const [shownTab, setShownTab] = useState(tab || location.state?.tab || TapToTipTabs.PROFILE);
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  let urlTab = null;

  const [shownTab, setShownTab] = useState(
    urlTab || tab || location.state?.tab || TapToTipTabs.PROFILE
  );
  // const [isRecommendModalOpen, setIsRecommendModalOpen] = useState(false);
  const isFeatureForCompanyEnabled = useIsFeatureForCompanyEnabled();
  const isReviewCollectionEnabled = isFeatureForCompanyEnabled('PostTipReviewCollection');

  return (
    <div>
      <TopNav sendInvitesToGuides={sendInvitesToGuides} />
      <div className={classes.container}>
        <TipDirectLeftMenu />
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  transactions: state.taptotip?.transactions,
  profile: state.taptotip?.profile,
  isLoading: state.taptotip?.isLoading,
  connectStripeResponse: state.taptotip?.connectStripeResponse,
  agentsProfiles: state.taptotip?.agentsProfiles,
  activeTours: state.taptotip?.activeTours,
  user: state.user?.user,
  reviewsStatistic: state.taptotip?.reviewsStatistic,
  tours: state.taptotip?.tours
});

const mapDispatchToProps = dispatch => ({
  fetchTransactions: userId => dispatch(actions.fetchTransactions({ userId })),
  fetchProfile: userId => dispatch(actions.fetchProfile(userId)),
  updateProfile: R.compose(
    dispatch,
    actions.updateProfile
  ),
  uploadUserProfileImage: image => dispatch(actions.uploadUserProfileImage(image)),
  connectStripe: () => dispatch(actions.connectStripe()),
  fetchAgentsProfiles: () => dispatch(actions.fetchAgentsProfiles()),
  sendInvitesToGuides: payload => dispatch(actions.sendInvitesToGuides(payload)),
  fetchActiveTours: () => dispatch(actions.fetchActiveTours()),
  addToursToProfile: (userId, tourIds) => dispatch(actions.addToursToProfile({ userId, tourIds })),
  addTapToTipTour: payload => dispatch(actions.addTapToTipTour(payload)),
  editTapToTipTour: payload => dispatch(actions.editTapToTipTour(payload)),
  fetchReviewsStatistic: payload => dispatch(actions.fetchReviewsStatistic(payload)),
  revokeInvite: payload => dispatch(actions.revokeInvite(payload)),
  fetchTours: () => dispatch(actions.fetchTours()),
  multipleAssign: (tourIds, guideIds) => dispatch(actions.multipleAssign({ tourIds, guideIds })),
  deleteTour: payload => dispatch(actions.deleteTour(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TapToTipPage);
